export default __webpack_public_path__ + "static/media/filter-icon.813edd52.svg";